import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        redirect: '/home',
    },
    {
        path: '/home',
        name: 'home',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/HomeView.vue')
    },
    {
        path: '/introduce',
        name: 'introduce',
        component: () =>
            import ('../views/Introduce.vue')
    },
    {
        path: '/brandCompet',
        name: 'brandCompet',
        component: () =>
            import ('../views/BrandCompet.vue')
    },
    {
        path: '/goods',
        name: 'goods',
        component: () =>
            import ('../views/Goods.vue')
    },
    {
        path: '/joinUs',
        name: 'joinUs',
        component: () =>
            import ('../views/JoinUs.vue')
    }
]
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router